import Ui from '../../../client/ui'

export default class
{
	protected static _timeout_second = 30

	static sync():void
	{
		if(!Ui.confirm('submit')) return
		Ui.indicator(true)

		Ui.post('/stylist/', {
			action: 'sync',
		}, (success:boolean, message:string) =>
		{
			Ui.indicator(false)

			if(success)
			{
				alert(message)
				location.reload()
			}
		}, this._timeout_second)
	}
}
